import { envs } from '@modules/core/services/envs';

export const BRANCH_KEY = envs.VITE_BRANCH_API_KEY as string | undefined;
export const BRANCH_DOMAIN = envs.VITE_BRANCH_LINK_DOMAIN as string | undefined;
export const BRANCH_STORE_SUFFIX = envs.VITE_BRANCH_STORE_SUFFIX as string | undefined;
